import { useState } from 'react';

import useOnKeyDown from '@/hooks/useOnKeyDown';

const ToggleDescriptionListItem = ({ className = '', num = '', text = '', title = '' }) => {
  const [isOpen, setOpen] = useState(false);
  const toggleOpenOption = () => setOpen((prev) => !prev);
  const onKeyDown = useOnKeyDown(toggleOpenOption);

  return (
    <li>
      <div
        className="toggleDescriptionList-item"
        onClick={toggleOpenOption}
        onKeyDown={onKeyDown}
        role="button"
        tabIndex="0"
      >
        <span dangerouslySetInnerHTML={{ __html: `${num}. ${title}` }} />
        <span>{isOpen ? '-' : '+'}</span>
      </div>
      <article className={`${className}__article`}>
        {isOpen && <span dangerouslySetInnerHTML={{ __html: text }} />}
      </article>
    </li>
  );
};

export default ToggleDescriptionListItem;
